const CODE = {
  SUCCESS: 0,
  FAIL: -1,
  // 未登录：
  // crm & boss: 255
  // dx ,mk ,erp: -10002. 暂时保留该状态码，但目前不做处理
  NO_LOGIN: 255,
  NO_LOGIN_OTHERS: -10002,
  EXPIRE: 260, // Redirect To：/expire
  EXCESS: 261, // Redirect To：/excess
  NEED_XIAOMAN_PASSWORD_VERIFY: 270, // 敏感操作-小满账密验证
  NEED_AMES_PHONE_VERIFICATION_CODE_VERIFY: 271, // 敏感操作-Ames短信验证
  AMES_NOT_BIND_PHONE: 272, // 敏感操作-Ames未绑定手机号
  LEADS_LOGIN_LIMIT: 280, // okki leads 独立售卖版多个设备登录限制
  NO_PRIVILEGE: 302, // Redirect To：/privilege
  DISABLE: 301, // Redirect To：/disable
  NEED_PURCHASE: 303, // Redirect To：/purchase
  ONLY_DISCOVERY_CODE: 304, // Redirect To: /discovery
  CRM_FORBIDDEN: 306, // 登录Ames后访问小满CRM下子页面
  AMES_FORBIDDEN: 307, // 登录小满后访问Ames的CRM子页面
  CONFIGURE_OMG_ENV_FOR_EXPERIENCE_ACCOUNT: 308, // 使用omg环境配置体验账号数据
  MAIL_NOT_FOUND: 1300,
  SYSTEM_UPGRADE: 999, //系统维护升级

  COMPANY_NOT_MINE: -20001, // 非本人客户
  COMPANY_RECYCLE: -20002, // 客户删除到回收箱
  COMPANY_DELETE: -20003, // 客户彻底删除

  BUSINESS_NOT_PRIVILEGE_VIEW: -110001, //无权限查看商机
  INVOICE_NOT_PRIVILEGE_VIEW: -30001, //无权限查看
  INVOICE_NOT_PRIVILEGE_MANAGE: -30002, //无权限管理
  INVOICE_NOT_RECYCLE: -30003, //单据已删除到回收箱
  INVOICE_NOT_DELETE: -30004, //单据已彻底删除

  CASH_COLLECTIONS_NOT_RECYCLE: -150001, //回款单已删除到回收箱
  CASH_COLLECTIONS_NOT_DELETE: -150002, //回款单已彻底删除

  PRODUCT_NOT_RECYCLE: -40001, //产品已删除到回收箱
  PRODUCT_NOT_DELETE: -40002, //产品已彻底删除

  AI_NOT_PRIVILEGE_VIEW: -60001, // AI 无权限查看

  CODE_SUPPLIER_NOT_PRIVILEGE_VIEW: -300001, //供应商无查看权限
  CODE_OMS_NOT_DELETE: -400006, // OMS 单据已删除

  // dx 使用
  OTHER_DEVICE_LOGIN: -70001, // 其他设备登录
  VERIFY_FAIL: -70002, // 验证失败
  DX_VIOLATION_WARNING: 70003, //弹出验证码
  DX_VIOLATION_24_HOURS: 70004, //24小时封禁
  DX_VIOLATION_FOREVER: 70005, //永久封禁

  // mk
  NO_DATA_PRIVILEGE: -10005, // 无权限

  EDM_NOT_PRIVILEGE_VIEW: -160001, // 无权限查看edm

  TRADE_DOCUMENT_DELETE: -600001, // 外贸文档已删除
}

export default CODE

export const NOT_PRIVILEGE_CODES = [
  CODE.NO_PRIVILEGE,
  CODE.COMPANY_NOT_MINE,
  CODE.INVOICE_NOT_PRIVILEGE_VIEW,
  CODE.BUSINESS_NOT_PRIVILEGE_VIEW,
  CODE.INVOICE_NOT_PRIVILEGE_MANAGE,
  CODE.CODE_SUPPLIER_NOT_PRIVILEGE_VIEW,
]

// 用于抽屉判断单据是否已删除
export const SPACE_DELETE_CODES = [
  CODE.CODE_OMS_NOT_DELETE,
  CODE.INVOICE_NOT_RECYCLE,
  CODE.INVOICE_NOT_DELETE,
  CODE.PRODUCT_NOT_RECYCLE,
  CODE.PRODUCT_NOT_DELETE,
]

const PRODUCT_LIST_TOO_MANY_RESULT = -40003

export const WARNING_CODES = [PRODUCT_LIST_TOO_MANY_RESULT]
